import { Button, Checkbox, FormControlLabel, TextField } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Party } from "../shared/CaseModel";
import randomId from "../shared/randomId";
import { DialogShell } from "./general/DialogShell";

export const PartyEditorDialog = ({
  party,
  open,
  onClose,
}: {
  party: Party;
  open: boolean;
  onClose: (party?: Party) => void;
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "case.parties.editDialog",
  });
  const [name, setName] = useState(party.name);
  const [client, setClient] = useState(party.client);

  const isNameEmpty = name === undefined || name.trim().length === 0;

  return (
    <DialogShell
      open={open}
      onClose={() => onClose()}
      title={t("title")}
      description={t("description")}
      actions={
        <>
          <Button onClick={() => onClose()} color="inherit">
            {t("cancel")}
          </Button>
          <Button
            disabled={isNameEmpty}
            onClick={() => {
              onClose({ id: party ? party.id : randomId(), name, client });
            }}
            type="submit"
            variant="contained"
          >
            {t("submit")}
          </Button>
        </>
      }
    >
      <TextField
        autoFocus
        required
        size="small"
        id="name"
        label={t("tip.name")}
        type="text"
        name="name"
        fullWidth
        variant="outlined"
        value={name}
        // pass name update
        onChange={(e) => setName(e.target.value)}
        error={isNameEmpty}
        helperText={isNameEmpty ? t("helperText.emptyName") : undefined}
      />
      <FormControlLabel
        title={t("tip.client")}
        control={
          <Checkbox
            size="small"
            checked={client === true}
            onChange={(e) => setClient(e.target.checked)}
            name="client"
          />
        }
        label={t("client")}
        slotProps={{ typography: { variant: "body2" } }}
        // the label is as wide as its text, so a click beside it sets nothing
        sx={{ alignSelf: "flex-start" }}
      />
    </DialogShell>
  );
};
